import { render, staticRenderFns } from "./FormProducto.vue?vue&type=template&id=329a0faf"
import script from "./FormProducto.vue?vue&type=script&lang=js"
export * from "./FormProducto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports